import type { ComponentProps } from 'react'

import { TextButton } from '../text-button'

import * as styles from './continue-button.styles'

type ButtonProps = ComponentProps<typeof TextButton>
type Props = ButtonProps

export const ContinueButton = ({ children, ...other }: Props) => (
  <TextButton
    color="primary"
    css={[
      styles.continueButton,
      (other.fullWidth ?? false) && styles.fullWidth,
    ]}
    data-testid="continue-button"
    type="submit"
    {...other}
  >
    {children}
  </TextButton>
)
